import {
  GET_DYNAMIC_DATA_SUCCESS,
  ADD_DYNAMIC_DATA_SUCCESS,
  UPDATE_DYNAMIC_DATA_SUCCESS,
  DELETE_DYNAMIC_DATA_SUCCESS,
  DYNAMIC_DATA_API_ERROR
  
} from "./actionTypes"

const INIT_STATE = {
  dynamicLists: [],
  dynamicData:[],
  error: {},
}

const DynamicDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DYNAMIC_DATA_SUCCESS:
      return {
        ...state,
        dynamicData: action.payload,
      }

    case ADD_DYNAMIC_DATA_SUCCESS:
      return {
        ...state,
        dynamicData: [...state.dynamicData, action.payload],
      }


    case UPDATE_DYNAMIC_DATA_SUCCESS:
      return {
        ...state,
        dynamicData: state.dynamicData.map(dynamicData =>
          dynamicData.guid.toString() === action.payload.guid.toString()
            ? { dynamicData, ...action.payload }
            : dynamicData
        ),
      }

    case DELETE_DYNAMIC_DATA_SUCCESS:
      return {
        ...state,
        dynamicData: state.dynamicData.filter(
          dynamicData => dynamicData.guid.toString() !== action.payload.guid.toString()
        ),
      }
    case DYNAMIC_DATA_API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state;
  }
}

export default DynamicDefinition;
